import React from "react";
import { alpha, Box, Grid, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { MeetingTool, SessionStepProps, VirtualSessionDraft } from "../types";

const TOOLS: MeetingTool[] = ["MSTEAMS", "GMEET", "OTHER"];

const DeliveryMethodStep: React.FC<SessionStepProps<VirtualSessionDraft>> = ({
  data,
  setData,
  errors,
  disabledFields,
}) => {
  const { t } = useTranslation("session-wizard");
  const theme = useTheme();

  const toolDisabled = disabledFields.has("tool");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Grid container spacing={2}>
        {TOOLS.map((tool) => {
          const selected = data.tool === tool;
          return (
            <Grid item xs={12} md={4} key={tool}>
              <Box
                role="button"
                onClick={() => {
                  if (!toolDisabled) setData({ tool });
                }}
                sx={{
                  position: "relative",
                  cursor: toolDisabled ? "default" : "pointer",
                  opacity: toolDisabled && !selected ? 0.5 : 1,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  padding: "20px",
                  borderRadius: "12px",
                  border: `1.5px solid ${
                    selected
                      ? theme.palette.primary.main
                      : theme.palette.divider
                  }`,
                  backgroundColor: selected
                    ? alpha(theme.palette.primary.main, 0.08)
                    : theme.palette.background.paper,
                  transition: "border-color .15s, background-color .15s",
                }}
              >
                {selected && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 12,
                      right: 12,
                      width: 20,
                      height: 20,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                    }}
                  >
                    <Check size={12} strokeWidth={3} />
                  </Box>
                )}
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    color: theme.palette.text.primary,
                  }}
                >
                  {t(`method.${tool}.title`)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: theme.palette.text.primary,
                  }}
                >
                  {t(`method.${tool}.description`)}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      {errors.tool && (
        <Typography sx={{ fontSize: "12px", color: theme.palette.error.main }}>
          {errors.tool}
        </Typography>
      )}
    </Box>
  );
};

export default DeliveryMethodStep;
